export default "__VITE_ASSET__B_BUDgXI__"